import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
export function FinalCTA() {
  const {
    language
  } = useLanguage();
  const t = translations[language].finalCTA;
  const scrollToBook = () => {
    const bookSection = document.getElementById('book-section');
    if (bookSection) {
      bookSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="py-20 px-4 bg-gradient-to-b from-black to-teal-950" data-id="element-163">
      <div className="max-w-4xl mx-auto text-center" data-id="element-164">
        <h2 className="text-4xl md:text-5xl font-bold mb-8 text-white" data-id="element-165">
          {t.title}
        </h2>
        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-166">
          <div className="bg-gradient-to-br from-red-950/30 to-black border border-red-600/30 rounded-xl p-8" data-id="element-167">
            <h3 className="text-2xl font-bold text-red-400 mb-4" data-id="element-168">{t.path1}</h3>
            <p className="text-lg text-gray-300" data-id="element-169">{t.path1Text}</p>
          </div>
          <div className="bg-gradient-to-br from-yellow-950/30 to-black border-2 border-yellow-600/50 rounded-xl p-8" data-id="element-170">
            <h3 className="text-2xl font-bold text-yellow-400 mb-4" data-id="element-171">
              {t.path2}
            </h3>
            <p className="text-lg text-gray-300" data-id="element-172">{t.path2Text}</p>
          </div>
        </div>
        <p className="text-xl mb-8 text-teal-200" data-id="element-173">{t.text}</p>
        <p className="text-2xl mb-8 text-yellow-400 font-semibold" data-id="element-174">
          {t.tomorrow}
        </p>
        <button onClick={scrollToBook} className="relative overflow-hidden w-full max-w-md mx-auto bg-gradient-to-r from-red-600 to-red-700 md:from-red-600 md:to-red-700 text-white px-8 py-5 rounded-full text-lg md:text-xl font-bold hover:from-red-500 hover:to-red-600 transform hover:scale-105 transition-all animate-pulse-glow before:content-[''] before:absolute before:inset-0 before:bg-gradient-to-r before:from-red-500 before:via-transparent before:to-red-700 before:opacity-0 md:before:opacity-100 after:content-[''] after:absolute after:left-0 after:top-0 after:bottom-0 after:w-1/2 after:bg-red-500 after:rounded-l-full after:md:hidden" data-id="element-175">
          <span className="relative z-10" data-id="element-176">{t.cta}</span>
        </button>
        <p className="mt-3 text-xs text-gray-400" data-id="element-177">{t.guarantee}</p>
      </div>
      <style data-id="element-178">{`
        @keyframes pulse-glow {
          0%, 100% {
            box-shadow: 0 0 20px rgba(59, 130, 246, 0.5), 0 0 40px rgba(59, 130, 246, 0.3), 0 0 60px rgba(59, 130, 246, 0.2);
          }
          50% {
            box-shadow: 0 0 30px rgba(59, 130, 246, 0.8), 0 0 60px rgba(59, 130, 246, 0.5), 0 0 90px rgba(59, 130, 246, 0.3);
          }
        }
        .animate-pulse-glow {
          animation: pulse-glow 3s ease-in-out infinite;
        }
      `}</style>
    </section>;
}